import { apiClient } from "../config";

export interface SnappingGeographiesParams {
  type: "region" | "shape";
  shape_type?: string;
  search_string?: string;
  limit?: number;
  page?: number;
}

async function getSnappingGeographies(
  communityId: string,
  params: SnappingGeographiesParams,
) {
  const res = await apiClient.get(
    `/admin/communities/${communityId}/snapping-geographies`,
    { params },
  );

  return res.data;
}

export default getSnappingGeographies;
